export default "__VITE_ASSET__D$ofKuPi__"